
import {
  Obra
} from '../index';


export class ObraEscopo {
  "ObraId";
  "tipoDoEscopo";
  "sla";
  "nome";
  "quantidade";
  "typeSite";
  "slaDaRegional";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraEscopo`.
   */
  static getModelName() {
    return "ObraEscopo";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraEscopo for dynamic purposes.
  **/
  static factory(data) {
    return new ObraEscopo(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraEscopo',
      plural: 'ObraEscopos',
      path: 'ObraEscopos',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "tipoDoEscopo": {
          name: 'tipoDoEscopo',
          type: 'string'
        },
        "sla": {
          name: 'sla',
          type: 'string'
        },
        "nome": {
          name: 'nome',
          type: 'string'
        },
        "quantidade": {
          name: 'quantidade',
          type: 'string'
        },
        "typeSite": {
          name: 'typeSite',
          type: 'string'
        },
        "slaDaRegional": {
          name: 'slaDaRegional',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraEscopo.js